import { Link, Outlet, useLocation, useParams, useSearchParams } from "react-router-dom";
import { useDateFromSearchParams } from "@/helpers/useTimeHooks";
import { Button, Card, Stack, Typography } from "@altimateai/lego";
import { ArrowLeftIcon } from "@assets/icons";
import { DateRange } from "@/components/dateRange";

export const CommonJobParentWithOutlet = ({ parent }: { parent: string }) => {
  const location = useLocation();
  const { hash } = useParams();
  const [searchParams] = useSearchParams();
  const { startDate, endDate, onUpdate } = useDateFromSearchParams();

  const getPreviousPath = () => {
    const parts = location.pathname.split("/").filter(Boolean);
    if (parts.length > 3) {
      return `/query/${parent}/${hash!}${location.search}`;
    } else {
      return `/query/${parent}`;
    }
  };
  return (
    <Card className="al-p-4">
      <Stack direction="column" className="gap-sm">
        <Stack align="center" justify="between">
          <Stack align={"center"} gap={"sm"}>
            <Button asChild size={"icon"} variant={"ghost"} title="Go back">
              <Link to={getPreviousPath()} aria-label="Go back">
                <ArrowLeftIcon />
              </Link>
            </Button>
            <Typography className={"!al-text-base"} variant={"section-heading"}>
              {searchParams.get("query_summary") || hash}
            </Typography>
          </Stack>
          <DateRange
            startDate={startDate}
            endDate={endDate}
            availableStaticRanges={["Last day", "Last 7 days", "Last 28 days"]}
            onDateRangeSelect={onUpdate}
          />
        </Stack>
        <div />
        <Outlet />
      </Stack>
    </Card>
  );
};
